import { useContext } from "react"
import { ErrorSuccess } from "../context/ErrorSuccess";

export const useErrorSuccess = () => {
  const context = useContext(ErrorSuccess);
  return context
}
